var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCursiveArrow1 = function SvgCursiveArrow1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 281 252"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB81C",
    strokeDasharray: "8 8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M250.778 66c-4.585 7.547-4.092 20.15-4.07 28.49.027 9.772 1.934 18.962 5.164 28.119.775 2.199 1.659 4.411 2.279 6.661.486 1.764-3.596-1.771-5.338-2.334-11.804-8.092-14.699-7.815-25.893-9.224-14.714-1.853-22.788-4.339-36.617-2.591"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB81C",
    strokeDasharray: "6 6",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M22.194 187.639c-4.493-8.48.29-21.017 3.002-29.368 4.22-12.993 10.712-24.648 19.45-35.234 16.67-20.193 42.734-44.936 70.338-47.178 40.999-3.331 23.814 86.751-7.705 60.43-13.44-11.223-8.53-36.201.323-48.826 14.408-20.55 30.538-42.998 55.338-51.052 30.77-9.992 63.807 32.006 65.707 59.478"
  })));
};
export default SvgCursiveArrow1;